import React, { useState } from 'react';
import './VPSTurkey.css';

const VPSTurkey = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const plans = [
    {
      tier: 'استارتر',
      price: '۲۲۰',
      unit: 'هزار تومان / ماه',
      cpu: '2 Core',
      ram: '۴ GB',
      storage: '۵۰ GB NVMe',
      features: ['لوکیشن ترکیه', 'پینگ عالی', 'قیمت مناسب', 'پشتیبانی ۲۴/۷'],
      popular: false,
    },
    {
      tier: 'پیشرفته',
      price: '۴۰۰',
      unit: 'هزار تومان / ماه',
      cpu: '4 Core',
      ram: '۸ GB',
      storage: '۱۰۰ GB NVMe',
      features: ['لوکیشن ترکیه', 'پینگ عالی', 'قیمت مناسب', 'پشتیبانی ۲۴/۷', 'IP اختصاصی'],
      popular: true,
    },
    {
      tier: 'حرفه‌ای',
      price: '۶۵۰',
      unit: 'هزار تومان / ماه',
      cpu: '8 Core',
      ram: '۱۶ GB',
      storage: '۲۰۰ GB NVMe',
      features: ['لوکیشن ترکیه', 'پینگ عالی', 'قیمت مناسب', 'پشتیبانی ۲۴/۷', 'IP اختصاصی', 'اولویت پشتیبانی'],
      popular: false,
    },
  ];

  const features = [
    {
      icon: '🇹🇷',
      title: 'لوکیشن استراتژیک ترکیه',
      desc: 'VPS ترکیه با موقعیت جغرافیایی عالی بین اروپا و آسیا، پینگ فوق‌العاده‌ای برای ایران و خاورمیانه دارد. بهترین گزینه برای وب‌سایت‌های فارسی با مخاطبان ایرانی و منطقه‌ای.',
    },
    {
      icon: '💰',
      title: 'قیمت مناسب و مقرون‌به‌صرفه',
      desc: 'VPS ترکیه با قیمت‌های بسیار رقابتی، گزینه‌ای عالی برای کسب‌وکارهایی است که به دنبال سرور مجازی با کیفیت بالا و هزینه مناسب هستند.',
    },
    {
      icon: '⚡',
      title: 'سرعت عالی برای کاربران ایرانی',
      desc: 'به دلیل نزدیکی جغرافیایی به ایران، VPS ترکیه سرعت بارگذاری فوق‌العاده‌ای برای کاربران ایرانی دارد. پینگ پایین و پهنای باند بالا تجربه کاربری بی‌نظیری را فراهم می‌کند.',
    },
    {
      icon: '🛡️',
      title: 'امنیت و پایداری بالا',
      desc: 'دیتاسنترهای ترکیه با استانداردهای امنیتی بالا و زیرساخت‌های پیشرفته، پایداری و امنیت عالی را برای سرور شما فراهم می‌کنند.',
    },
  ];

  const faqs = [
    {
      q: 'VPS ترکیه برای چه نوع وب‌سایت‌هایی مناسب است؟',
      a: 'VPS ترکیه به دلیل پینگ بسیار عالی برای ایران و خاورمیانه، برای وب‌سایت‌های فارسی با مخاطبان ایرانی، فروشگاه‌های آنلاین، وب‌سایت‌های خبری و هر نوع وب‌سایتی که مخاطبان آن در ایران و منطقه هستند، بسیار مناسب است. همچنین برای کسب‌وکارهایی که به دنبال لوکیشنی با قیمت مناسب و کیفیت بالا هستند، گزینه‌ای ایده‌آل محسوب می‌شود.',
    },
    {
      q: 'آیا VPS ترکیه برای بازی‌های آنلاین مناسب است؟',
      a: 'بله، VPS ترکیه با پینگ پایین و پهنای باند بالا، گزینه‌ای عالی برای میزبانی بازی‌های آنلاین است. بسیاری از گیمرهای ایرانی از VPS ترکیه برای بازی‌های آنلاین و ایجاد سرورهای بازی استفاده می‌کنند.',
    },
  ];

  return (
    <>
      <div className="seo-header">
        <h1>VPS ترکیه | خرید سرور مجازی ترکیه با بهترین قیمت | افرسل</h1>
        <p>خرید VPS ترکیه با پینگ عالی برای ایران، قیمت مناسب و پشتیبانی ۲۴ ساعته. سرور مجازی ترکیه مناسب برای وب‌سایت‌های فارسی، فروشگاه‌های آنلاین و بازی‌های آنلاین.</p>
        <meta name="description" content="خرید VPS ترکیه با بهترین قیمت از افرسل. سرور مجازی ترکیه با پینگ عالی، قیمت مناسب، NVMe و پشتیبانی ۲۴/۷." />
      </div>

      <section className="vps-turkey-hero">
        <div className="vps-turkey-hero-bg"></div>
        <div className="wrap">
          <div className="vps-turkey-hero-content">
            <div className="vps-turkey-badge">
              <span className="pulse-dot"></span>
              🇹🇷 VPS ترکیه
            </div>
            <h1 className="vps-turkey-hero-title">
              سرور مجازی <em>ترکیه</em>
            </h1>
            <p className="vps-turkey-hero-desc">
              VPS ترکیه با پینگ عالی برای ایران، قیمت مناسب و پشتیبانی ۲۴ ساعته.
              بهترین گزینه برای وب‌سایت‌های فارسی، فروشگاه‌های آنلاین و بازی‌های آنلاین.
            </p>
            <div className="vps-turkey-hero-stats">
              <div className="stat-item">
                <span className="stat-number">۳</span>
                <span className="stat-label">پلن مختلف</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">ترکیه</span>
                <span className="stat-label">لوکیشن</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۲۴/۷</span>
                <span className="stat-label">پشتیبانی</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="vps-turkey-plans">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">پلن‌های VPS ترکیه</span>
            <h2 className="sec-h">پلن <em>مناسب</em> پروژه خود را انتخاب کنید</h2>
            <p className="sec-p">پلن‌های متنوع VPS ترکیه با قیمت‌های رقابتی و منابع کافی برای هر نوع پروژه.</p>
          </div>
          <div className="vps-turkey-plans-grid">
            {plans.map((plan, i) => (
              <div key={i} className={`vps-turkey-plan ${plan.popular ? 'popular' : ''}`}>
                {plan.popular && <span className="vps-turkey-popular-badge">پرفروش‌ترین</span>}
                <div className="vps-turkey-plan-tier">{plan.tier}</div>
                <div className="vps-turkey-plan-price">
                  <span className="vps-turkey-plan-num">{plan.price}</span>
                  <span className="vps-turkey-plan-unit">{plan.unit}</span>
                </div>
                <div className="vps-turkey-plan-specs">
                  <div><span>🖥️</span> {plan.cpu}</div>
                  <div><span>💾</span> {plan.ram}</div>
                  <div><span>📀</span> {plan.storage}</div>
                </div>
                <ul className="vps-turkey-plan-features">
                  {plan.features.map((feat, j) => (
                    <li key={j}><span>✓</span> {feat}</li>
                  ))}
                </ul>
                <button className="vps-turkey-order-btn" onClick={() => scrollTo('contact')}>سفارش دهید</button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="vps-turkey-features">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">مزایای VPS ترکیه</span>
            <h2 className="sec-h">چرا <em>VPS ترکیه</em> با افرسل؟</h2>
            <p className="sec-p">VPS ترکیه با بهترین امکانات برای کاربران ایرانی و منطقه.</p>
          </div>
          <div className="vps-turkey-features-grid">
            {features.map((feature, i) => (
              <div key={i} className="vps-turkey-feature-card">
                <span className="vps-turkey-feature-icon">{feature.icon}</span>
                <h3 className="vps-turkey-feature-title">{feature.title}</h3>
                <p className="vps-turkey-feature-desc">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="vps-turkey-faq">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">سوالات متداول</span>
            <h2 className="sec-h">پاسخ به <em>سوالات</em> شما</h2>
          </div>
          <div className="vps-turkey-faq-grid">
            {faqs.map((faq, i) => (
              <div key={i} className="vps-turkey-faq-item">
                <div className="vps-turkey-faq-q">{faq.q}</div>
                <div className="vps-turkey-faq-a">{faq.a}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="vps-turkey-cta">
        <div className="wrap">
          <div className="cta-box">
            <h2 className="cta-title">
              VPS <em>ترکیه</em> را همین حالا خریداری کنید
            </h2>
            <p className="cta-desc">
              با خرید VPS ترکیه، از پینگ عالی، قیمت مناسب و پشتیبانی ۲۴ ساعته بهره‌مند شوید.
            </p>
            <div className="cta-btns">
              <button className="btn-lg primary" onClick={() => scrollTo('contact')}>خرید VPS</button>
              <button className="btn-lg ghost" onClick={() => scrollTo('contact')}>مشاوره رایگان</button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default VPSTurkey;
